export class DisposalPlacesContentModel {
    public disposalPlaceId: number;
    public langId: number;
    public city: string;
    public region: string;
    public address: string;
    public description: string;
}